export var YearsPerSlide = 5;
export var Actions = {
  SELECT_YEAR: 'SELECT_YEAR',
  SELECT_MONTH: 'SELECT_MONTH',
  SELECT_DAY: 'SELECT_DAY'
};
export var MonthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
export var WeekDays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];